export default __webpack_public_path__ + "static/media/cs.7fb22ad0.md";